/*
  Jenniferloyo.sport — scroll reveal for homepage sections.
  Content stays visible if this script never runs: the hidden state only
  applies after <html> receives the .jl-motion class below.
*/
(() => {
  if (window.JlReveal) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supported = 'IntersectionObserver' in window;
  let observer = null;

  if (!reduceMotion && supported) {
    document.documentElement.classList.add('jl-motion');
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
  }

  const scan = (root = document) => {
    root.querySelectorAll('[data-jl-reveal]:not(.is-visible)').forEach((element) => {
      if (observer) {
        observer.observe(element);
      } else {
        element.classList.add('is-visible');
      }
    });
  };

  window.JlReveal = { scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  // Theme Editor: re-scan sections that are added, reloaded or reordered.
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    event.target.classList.add('is-visible');
    event.target.querySelectorAll('[data-jl-reveal]').forEach((element) => element.classList.add('is-visible'));
  });
})();
